import React from 'react';
import { Link } from 'react-router-dom';
import { translate } from './Translations';

import { useLanguage } from './LanguageContext';

function CaseStudies() {
    const { language } = useLanguage();
    return (
        <>
        <div className='w-full flex flex-col justify-center items-start text-black sm:p-12 sm:px-24 p-7' id='case-studies'>
            <h1 className='font-semibold text-left text-3xl' data-aos="fade-right" data-aos-delay="100">
                {translate('caseStudies', language)}
            </h1>
            <h2 className='font-normal text-left text-xl' data-aos="fade-right" data-aos-delay="200"> 
                {translate('caseStudiesSubt', language)}
            </h2>
        </div>
        <div 
            className='flex flex-row gap-4 mb-12 sm:overflow-hidden overflow-y-hidden overflow-x-scroll w-screen items-center justify-start sm:justify-center sm:h-80 h-60 px-4'
            style={{ minWidth: '100vw', paddingLeft: '16px', paddingRight: '16px' }}
        >
            <div className='flex flex-col items-center justify-center' data-aos="fade-up" data-aos-delay="400">
                <Link to={`/case-study?case=Rumi`} className='sm:w-[200px] w-44 hover:scale-105 transition-all ease-in-out aspect-square rounded-2xl relative flex items-center justify-center'>
                    <img className='z-20' src='rumi_logo.webp' alt="Rumi" />
                    <img className='absolute inset-0 w-full h-full object-cover rounded-2xl aspect-square' src='/rumi/rumi_bg.webp' alt="Rumi" />
                    <div className='absolute inset-0 w-full h-full object-cover rounded-2xl aspect-square bg-black opacity-60' alt="BG" />
                </Link>
                <a className='text-black underline mt-2 hover:scale-105 transition duration-150' href="/case-study?case=Rack">
                    {translate('seeMore', language)}
                </a>
            </div>

            <div className='flex flex-col items-center justify-center' data-aos="fade-up" data-aos-delay="400">
                <Link to={`/case-study?case=Casa+Zorba`} className='sm:w-[200px] w-44 hover:scale-105 transition-all ease-in-out aspect-square rounded-2xl relative flex items-center justify-center'>
                    <img className='z-20' src='/cz/cz.webp' alt="Casa Zorba" />
                    <img className='absolute inset-0 w-full h-full object-cover rounded-2xl aspect-square' src='zorba_bg.webp' alt="CZ" />
                    <div className='absolute inset-0 w-full h-full object-cover rounded-2xl aspect-square bg-black opacity-60' alt="BG" />
                </Link>
                <a className='text-black underline mt-2 hover:scale-105 transition duration-150' href="/case-study?case=Rack">
                    {translate('seeMore', language)}
                </a>
            </div>





            <div className='flex flex-col items-center justify-center' data-aos="fade-up" data-aos-delay="400">
                <Link to={`/case-study?case=Rack`} className='sm:w-[200px] w-44 hover:scale-105 transition-all ease-in-out aspect-square rounded-2xl'>
                    <img className='w-full h-full object-cover rounded-2xl aspect-square' src='rack/dos.webp' alt="Rack" />
                </Link>
                <a className='text-black underline mt-2 hover:scale-105 transition duration-150' href="/case-study?case=Rack">
                    {translate('seeMore', language)}
                </a>
            </div>
            

            <div className='flex flex-col items-center justify-center' data-aos="fade-up" data-aos-delay="300">
                <Link to={`/case-study?case=Endless`} className='sm:w-[200px] w-44 hover:scale-105 transition-all ease-in-out aspect-square rounded-2xl'>
                    <img className='w-full h-full object-cover rounded-2xl aspect-square' src='img/endless.webp' alt="Endless" />
                </Link>
                <a className='text-black underline mt-2 hover:scale-105 transition duration-150' href="/case-study?case=Endless">
                    {translate('seeMore', language)}
                </a>
            </div>

            <div className='flex flex-col items-center justify-center' data-aos="fade-up" data-aos-delay="400">
                <Link to={`/case-study?case=Strix`} className='sm:w-[200px] w-44 hover:scale-105 transition-all ease-in-out aspect-square rounded-2xl'>
                    <img className='w-full h-full object-cover rounded-2xl aspect-square' src='img/strix.webp' alt="Strix" />
                </Link>
                <a className='text-black underline mt-2 hover:scale-105 transition duration-150' href="/case-study?case=Strix">
                    {translate('seeMore', language)}
                </a>
            </div>

        </div>
        </>
    );
}

export default CaseStudies;
